import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "doctor/patient";
const options = {role: ROLE.DOCTOR};


export const list = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/list`, values);
}

export const add = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/add`, values);
}

export const edit = async (values, role) => {
  return await axiosInstance(role ? { role } : options).put(`${path}/edit`, values);
}

export const deletePatient = async (values, role) => {
  return await axiosInstance(role ? { role } : options).delete(`${path}/delete?o_id=${values.o_id}`);
}

export const detail = async (values, role) => {
  console.log(values, '---values');
  return await axiosInstance(role ? { role } : options).get(`${path}/details?patient_id=${values.patient_id}`, values);
}

export const changeStatus = async (values, role) => {
  return await axiosInstance(role ? { role } : options).patch(`${path}/change-status`, values);
}

export const editHealth = async (values, role) => {
  return await axiosInstance(role ? { role } : options).put(`${path}/update-health-matrix`, values);
}

export const sendOTP = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/send-patient-history-otp`, values);
}

export const verifyOTP = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/list-patient-history`, values);
}


export const createPrescription = async (values) => {
  return await axiosInstance(options).post(`${path}/create-patient-history`, values);
}
export const getPrescription = async (values,role) => {
  return await axiosInstance(role ? {role} : options).post(`${path}/get-patient-history`, values);
}
export const updatePrescription = async (values) => {
  return await axiosInstance(options).post(`${path}/update-patient-history`, values);
}

export const uploadMedicalHistoryDocument = async (values) => {
  return await axiosInstance(options).post(`${path}/upload-medical-history-document`, values);
}

export const addAppointments = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/create-appointment`, values);
}
export const listAppointments = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/list-appointment`, values);
}
export const editAppointments = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/update-appointment`, values);
}
export const getAppointments = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/get-appointment`, values);
}
export const medicalHistoryDocument = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/get-medical-history-documents`, values);
}
export const getAllPatient = async (role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/get-all-patients`);
}
export const appointmentCancel = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/change-appointment-status`, values);
}

export const historyHealthMatrix = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/history-health-matrix`, values);
}

export const dietChartAdd = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/add-diet-chart`, values);
}

export const dietChartDetails = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/diet-chart-details`, values);
}

export const dietChartGenerate = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/generate-diet-chart`, values);
}

export const dietChartHistory = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/diet-chart-history`, values);
}

export const rescheduleAppointments = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/reschedule-appointment`, values);
}

export const feedbackAppointments = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/feedback-appointment`, values);
}
export const feedbackSMS = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/send-feedback-sms`, values);
}
export const historyFeedback = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/feedback-history-appointment`, values);
}

export const createMedicalCondition = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/create-medical-condition`, values);
}
export const medicalConditions = async (values, role) => {
  return await axiosInstance(role ? { role } : options).get(`${path}/get-medical-conditions?search=${values}`);
}
export const medicalConditionsByIds = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/get-medical-conditions-by-ids`, values);
}
